import { ListItemIcon, MenuItem } from '@mui/material';
import Agrupar from "../../../../imgComponents/agrupar.png";

import { refresh_token } from "../../../../main_components/tokens/tokenrefresh";

import { expenses_group_post } from "../../../../services/expenses/expense";
const SPECIAL_ACTIONS = (props) => {

  const agrupar_gastos = async () => {
    Object.keys(props.rowSelection).filter((clave) => props.rowSelection[clave]);

    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        props.setIsLoading(true);
        props.setmodalT(true)
        var data = { expenses: props.total_rows.getSelectedRowModel().rows.map(d => { return { id: d.original.id } }) };
        try {
          await expenses_group_post(data);
          props.setmodalT(false)
          window.location = "/expense_report";

        } catch (error) {
          console.log(error);
          alert(error?.response?.data?.errorMessage?.es);

        } finally {
          props.setmodalT(false)

          props.setIsLoading(false);
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }

  }

  return (
    <div>
      <MenuItem
        key={2}
        onClick={async () => {
          // props.closeMenu();
          agrupar_gastos()
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <img
            alt=""
            src={Agrupar}
            title="Agrupar Gastos"
            className=""
          ></img>
        </ListItemIcon>
      </MenuItem>

    </div>

  );
}
export default SPECIAL_ACTIONS;